var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    class: _vm.classess,
    attrs: {
      "type": _vm.type,
      "disabled": _vm.loading || _vm.disabled,
      "id": _vm.id
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('click');
      }
    }
  }, [_vm._v("\n  " + _vm._s(_vm.label) + "\n  "), !_vm.loading ? _c('i', {
    class: "fa fa-".concat(_vm.icon, " ml-2")
  }) : _vm._e(), _vm.loading ? _c('b-spinner', {
    staticClass: "ml-2",
    attrs: {
      "small": "",
      "variant": "light"
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }